/* eslint-disable no-unused-vars */
import { API } from "aws-amplify";

export const ExecuteMutation = async (query, variables) => {
  let res = await API.graphql({
    query: query,
    variables,
  }).catch((e) => {
    console.log("Error:", e);
  });
  if (!res || !res.data) return null;
  let [[_, Value]] = Object.entries(res.data);
  return Value;
};

export const ExecuteQuery = async (query, variables) => {
  let nextToken;
  let res = await API.graphql({
    query: query,
    variables,
  }).catch((e) => {
    console.log("Error:", e);
  });
  if (!res || !res.data) return null;
  let [[_, Value]] = Object.entries(res.data);
  nextToken = Value?.nextToken;
  return Value;
};
